import styles from './TextBlock.module.scss'

interface TextBlockProps {
    children: JSX.Element
}

export default function TextBlock({ children }: TextBlockProps) {
    return <div className={styles.root}>{children}</div>
}
